<template lang="pug">
  section(id="other-features")
     .goscontainer
        v-container
          .heading Основные возможности системы
          v-row
            v-col( v-for="(feature, i) in features"
                   :key="i"
                   cols="12"
                   md="6")
          
              div.mb-8.d-flex.pt-2
                v-avatar(
                  color="#ED0E51"
                  size=96)
                
                  v-img(:src="require(`@/assets/img/home/${feature.icon}.svg`)")
              
                div.ml-6
                  div.text {{feature.text}}

            
</template>

<script>
  export default {
    name: 'SectionOtherFeatures',
    data: () => ({
      features: [
        {
          title: '',
          text: 'Гибкое распределение дел с учетом различных критериев',
          icon: 'i1',
        },
        {
          title: '',
          text: 'Создание документов на основе собственных или предустановленных шаблонов',
          icon: 'i2',
        },
        {
          title: '',
          text: 'Организация и планирование для оптимизации загрузки аппарата суда',
          icon: 'i3',
        },
        {
          title: '',
          text: 'Формирование почтовых отправлений и отслеживание статуса доставки в кабинете судьи',
          icon: 'i4',
        },
        {
          title: '',
          text: 'Библиотека знаний, документооборот, файловое хранилище',
          icon: 'i5',
        },
        {
          title: '',
          text: 'Проведение удаленных судебных заседаний',
          icon: 'i6',
        },
        {
          title: '',
          text: 'Отправка электронных запросов и уведомлений',
          icon: 'i7',
        },
        {
          title: '',
          text: 'Электронные конвойные поручения и расписки (взаимодействие с ФСИН)',
          icon: 'i8',
        },
      ],
    }),
  }
</script>

<style lang="sass" scoped>
  #other-features
    padding: 32px 16px 
    background-color: #FFFFFF
    color: #000000
    .heading 
        font-family: $slab
        font-weight: 300
        font-size: 32px
        margin-bottom: 48px
        color:#505254
    .text
        font-size: 24px
        font-weight: 300
        line-height: 32px
  @media (max-width: 960px) 
    #other-features
      .text
          font-size: 20px
</style>
